var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgGroupAdd = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 11C12.1828 11.0023 13.2566 10.3093 13.7418 9.2305C14.2269 8.15174 14.0329 6.88859 13.2464 6.00514C12.4599 5.12169 11.2276 4.78287 10.1 5.13999C11.2983 6.85837 11.2983 9.1416 10.1 10.86C10.3911 10.9522 10.6946 10.9994 11 11ZM6 11C7.65685 11 9 9.65684 9 7.99999C9 6.34313 7.65685 4.99999 6 4.99999C4.34314 4.99999 3 6.34313 3 7.99999C3 9.65684 4.34314 11 6 11ZM11.89 16.55C12.046 16.8595 12.0305 17.2277 11.8492 17.5231C11.6679 17.8185 11.3466 17.9989 11 18H0.999996C0.653403 17.9989 0.332067 17.8185 0.150759 17.5231C-0.0305493 17.2277 -0.0459733 16.8595 0.109996 16.55L1.11 14.65C1.61177 13.6538 2.62476 13.0183 3.74 13H8.26C9.39327 12.9996 10.43 13.6379 10.94 14.65L11.89 16.55ZM21 9.99999H23.5C23.7761 9.99999 24 10.2238 24 10.5V11.5C24 11.7761 23.7761 12 23.5 12H21V14.5C21 14.7761 20.7761 15 20.5 15H19.5C19.2239 15 19 14.7761 19 14.5V12H16.5C16.2239 12 16 11.7761 16 11.5V10.5C16 10.2238 16.2239 9.99999 16.5 9.99999H19V7.49999C19 7.22384 19.2239 6.99999 19.5 6.99999H20.5C20.7761 6.99999 21 7.22384 21 7.49999V9.99999ZM13.26 13C14.3933 12.9996 15.43 13.6379 15.94 14.65L16.89 16.55C17.046 16.8595 17.0305 17.2277 16.8492 17.5231C16.6679 17.8185 16.3466 17.9989 16 18H13.82C14.0986 17.2316 14.0516 16.3829 13.69 15.65L12.74 13.76C12.6037 13.4925 12.443 13.238 12.26 13H13.26Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/group_add.addca6c3.svg";
export { ForwardRef as ReactComponent };